import React from 'react';
import { FormikProps } from 'formik';
import { useNavigate } from 'react-router-dom';
import { Form } from '@codehesion-za/headless';

import { DonationValues, DonationProps } from './types';
import { FormComponent, RecaptchaComponent } from '@project/components';
import { donationSchema } from './schema';
import { ROBOT_CHECK_PASS } from '@project/helper';
import { useSessionStorage } from '@project/hooks';

export const DonationForm: React.FC<DonationProps> = ({ formType }) => {
  const navigate = useNavigate();
  const [roboCheck, setRebotCheck] = useSessionStorage(ROBOT_CHECK_PASS, false);

  const onSubmitForm = (formData: DonationValues) => {
    navigate(
      `/payment?type=${formData.donationType}&amount=${formData.donationAmount}&currency=${
        formData.donationCurrency
      }&payment_type=${formType === 'special' ? 'donation' : 'global_donation'}&prayer_requests=${
        formData.prayerRequests
      }&payment_method=${formData.paymentMethod}`,
    );
    return new Promise(() => null);
  };

  const FormComponents = ({}: FormikProps<DonationValues>) => <FormComponent formType={formType} />;

  return roboCheck ? (
    <Form
      initialValues={{
        donationAmount: 1,
        donationCurrency: 'USD',
        donationType: formType === 'special' ? '' : 'North America',
        prayerRequests: [],
        paymentMethod: 'debit_credit',
      }}
      onSubmitForm={onSubmitForm}
      render={FormComponents}
      validationSchema={donationSchema}
    />
  ) : (
    <div className="my-2">
      <p>Verify you’re not a robot to continue</p>
      <RecaptchaComponent setRebotCheck={setRebotCheck} />
    </div>
  );
};
